import { Company, CompanyType, Timestamp, User } from 'api/models';
import { AccountPermissionSetType } from 'stores/permission-sets';

export enum PartnerPermissionName {
  Permissive = 'PERMISSIVE',
  Moderate = 'MODERATE',
  Restricted = 'RESTRICTED',
}
export interface PartnerPermission {
  partnerPermissionSetId: number;
  partnerPermissionSetName: PartnerPermissionName;
}
export interface PartnerCompany extends Company {
  admins: User[];
  accessLevel: PartnerPermission;
  maxSeat: number;
  active: boolean;
  usedSeat: number;
  activeProject: number;
  completedProject: number;
  strategic: boolean;
  createdAt: Timestamp;
}

export interface CreatePartnerPayload
  extends Omit<
    PartnerCompany,
    | 'companyId'
    | 'admins'
    | 'accessLevel'
    | 'usedSeat'
    | 'activeProject'
    | 'completedProject'
    | 'createdAt'
  > {
  companyType: CompanyType.Partner;
  admins: { emailId: string }[];
  accessLevel: {
    partnerPermissionSetId: number;
  };
}

export interface PartnerUser extends User {
  permissionSetName?: string;
  permissionSetType?: AccountPermissionSetType;
}
